import React from 'react';
import { Link } from 'react-router-dom';
import { Target, Eye, Award, Users, ArrowRight } from 'lucide-react';
import { companyInfo } from '../mock';
import { SEO } from '../components/SEO';

export const About = () => {
  return (
    <div className="dark-container">
      <SEO 
        title="About Us - NEXEN DIGITAL | Website & App Development Company Bhubaneswar"
        description="Learn about NEXEN DIGITAL, a leading website development and app development company in Bhubaneswar. We are AI-first development agency delivering exceptional digital solutions in Odisha."
        keywords="about nexen digital, website development company bhubaneswar, app development company bhubaneswar, AI development agency, digital solutions bhubaneswar, web development team, odisha"
      />
      {/* Hero Section */}
      <section style={{ padding: '100px 0 60px', textAlign: 'center' }}>
        <h1 className="display-huge" style={{ marginBottom: '24px', color: '#FFFFFF' }}>
          About <span style={{ color: '#00FFD1' }}>NEXEN DIGITAL</span>
        </h1>
        <p className="body-large" style={{ maxWidth: '800px', margin: '0 auto', color: 'rgba(255, 255, 255, 0.85)' }}>
          {companyInfo.about}
        </p>
      </section>

      {/* Mission & Vision */}
      <section style={{ padding: '60px 0' }}>
        <div style={{ maxWidth: '1400px', margin: '0 auto', display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(400px, 1fr))', gap: '40px' }}>
          <div style={{ background: '#121212', padding: '60px', border: '1px solid rgba(255, 255, 255, 0.25)' }}>
            <Target size={48} style={{ color: '#00FFD1', marginBottom: '24px' }} />
            <h2 className="heading-1" style={{ marginBottom: '20px', color: '#FFFFFF' }}>Our Mission</h2>
            <p className="body-large" style={{ color: 'rgba(255, 255, 255, 0.85)' }}>
              {companyInfo.mission}
            </p>
          </div>
          <div style={{ background: '#121212', padding: '60px', border: '1px solid rgba(255, 255, 255, 0.25)' }}>
            <Eye size={48} style={{ color: '#00FFD1', marginBottom: '24px' }} />
            <h2 className="heading-1" style={{ marginBottom: '20px', color: '#FFFFFF' }}>Our Vision</h2>
            <p className="body-large" style={{ color: 'rgba(255, 255, 255, 0.85)' }}>
              {companyInfo.vision}
            </p>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section style={{ padding: '100px 0', background: '#121212' }}>
        <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
          <h2 className="display-large" style={{ textAlign: 'center', marginBottom: '60px', color: '#FFFFFF' }}>
            Our <span style={{ color: '#00FFD1' }}>Core Values</span>
          </h2>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '40px' }}>
            {companyInfo.values.map((value, idx) => (
              <div key={idx} style={{ background: '#000000', padding: '40px', border: '1px solid rgba(255, 255, 255, 0.25)' }}>
                <Award size={40} style={{ color: '#00FFD1', marginBottom: '20px' }} />
                <h3 className="heading-2" style={{ marginBottom: '16px', color: '#FFFFFF' }}>
                  {value.title}
                </h3>
                <p className="body-medium" style={{ color: 'rgba(255, 255, 255, 0.85)' }}>
                  {value.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section style={{ padding: '100px 0' }}>
        <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
          <h2 className="display-large" style={{ textAlign: 'center', marginBottom: '60px', color: '#FFFFFF' }}>
            Our <span style={{ color: '#00FFD1' }}>Journey</span> in Numbers
          </h2>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '60px', textAlign: 'center' }}>
            {companyInfo.stats.map((stat, idx) => (
              <div key={idx}>
                <Users size={48} style={{ color: '#00FFD1', margin: '0 auto 20px', display: 'block' }} />
                <div className="display-medium" style={{ color: '#FFFFFF', marginBottom: '12px' }}>
                  {stat.value}
                </div>
                <div className="body-large" style={{ color: 'rgba(255, 255, 255, 0.85)' }}>
                  {stat.label}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section style={{ padding: '100px 0', background: '#121212' }}>
        <div style={{ maxWidth: '800px', margin: '0 auto', textAlign: 'center' }}>
          <h2 className="display-large" style={{ marginBottom: '24px', color: '#FFFFFF' }}>
            Join Us on Our <span style={{ color: '#00FFD1' }}>Mission</span>
          </h2>
          <p className="body-large" style={{ marginBottom: '40px', color: 'rgba(255, 255, 255, 0.85)' }}>
            Whether you're looking to build something amazing or want to be part of our team, we'd love to hear from you.
          </p>
          <div style={{ display: 'flex', gap: '20px', justifyContent: 'center', flexWrap: 'wrap' }}>
            <Link to="/contact" className="btn-primary">
              Get in Touch
              <ArrowRight size={20} />
            </Link>
            <Link to="/career" className="btn-secondary">
              View Career Opportunities
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};